import axios from 'axios'
import ConsoleLocalStorage from '../../storage/storage';
import { APP_MANAGEMENT_URL } from "../../config";



export default class AMStorageAPI {

    instance = axios.create({
        baseURL: APP_MANAGEMENT_URL,
        headers: { 'Authorization': 'Bearer ' + ConsoleLocalStorage.getAccessToken() }
    });
    sasInstance = axios.create({
        baseURL: APP_MANAGEMENT_URL,
        // headers: {'Authorization':'Bearer '+ConsoleLocalStorage.getAccessToken()}
    });


    generateAMSAS(data) {
      

        return this.instance.post('service/sas', data, {
            headers: {

                'x-organization-id': ConsoleLocalStorage.getUser().organization
            }
        });
    }

    generateGraphicSAS(applicationId, data) {



        return this.instance.post('service/' + applicationId + '/sas', data, {
            headers: {

                'x-organization-id': ConsoleLocalStorage.getUser().organization
            }
        });
    }

    uploadFile(cancelTokenSource,url, file, onProgress) {
        // var pro = new Promise((resolve,reject)=>{

        // var ins = axios.create({

        // });
        // var formData = new FormData();
        // formData.append('file',file);


        // var promise = new Promise(this.getBuffer(file));


        // promise.then(result=>{
        //     resolve(ins.put(url,result,{headers: {

        //         'x-ms-blob-type':'BlockBlob',
        //         'Content-Type': 'image/png'
        //     },
        //         onUploadProgress:(progressEvent)=>{

        //             onProgress((progressEvent.loaded / progressEvent.total) * 100);
        //         }
        //       }));
        // })


        // var fr = new FileReader();
        // fr.readAsArrayBuffer((file));
        // fr.onload = function() {
        // var data = fr.result;
        // var array = new Int8Array(data);

        // console.log('Read Done');
        // if(!hasConnection){
            
        //     cancelTokenSource.cancel();
        // }

        return this.sasInstance.put(url, file, {
            cancelToken: cancelTokenSource.token,
            headers: {

                'x-ms-blob-type': 'BlockBlob',
                // 'Content-Type': file.type
            },
            onUploadProgress: (progressEvent) => {

                onProgress((progressEvent.loaded / progressEvent.total) * 100);
            }
        })
        //   .then(response=>resolve(response)).catch(error=>reject(error));

        //   };

        // });

        // return pro;



    }


    uploadGraphicsFile(url, file, onProgress) {


        return this.sasInstance.put(url, file, {
            headers: {

                'x-ms-blob-type': 'BlockBlob',
                // 'Content-Type': file.type
            },
            onUploadProgress: (progressEvent) => {

                onProgress((progressEvent.loaded / progressEvent.total) * 100);
            }
        })
        //   .then(response=>resolve(response)).catch(error=>reject(error));

        //   };

        // });

        // return pro;



    }


}


